import { mutator } from 'satcheljs';
import {
    setCustomReminderDate,
    setSelectedDate,
    setSelectedTime,
} from '../actions/customReminderDateActions';
import emailReminderStore from '../store/store';
import getCustomReminderDate from '../selectors/getCustomReminderDate';
import { owaDate, getYear, getMonth, getDate, getHours, getMinutes } from 'owa-datetime';

mutator(setCustomReminderDate, actionMessage => {
    emailReminderStore.customReminderDate = actionMessage.customReminderDate;
});

mutator(setSelectedDate, ({ date }) => {
    const curCustomReminderDate = getCustomReminderDate();

    const startHours = getHours(curCustomReminderDate);
    const startMinutes = getMinutes(curCustomReminderDate);

    // Get the new start date values
    const newStartYear = getYear(date);
    const newStartMonth = getMonth(date);
    const newStartDate = getDate(date);

    // Set new customDateTime
    const newCustomReminderDate = owaDate(
        curCustomReminderDate,
        newStartYear,
        newStartMonth,
        newStartDate,
        startHours,
        startMinutes
    );

    emailReminderStore.customReminderDate = newCustomReminderDate;
});

mutator(setSelectedTime, ({ dateTime }) => {
    const curCustomReminderDate = getCustomReminderDate();
    const newStartHours = getHours(dateTime);
    const newStartMinutes = getMinutes(dateTime);

    const startYear = getYear(curCustomReminderDate);
    const startMonth = getMonth(curCustomReminderDate);
    const startDate = getDate(curCustomReminderDate);

    // Set new customDateTime
    const newCustomReminderDate = owaDate(
        curCustomReminderDate,
        startYear,
        startMonth,
        startDate,
        newStartHours,
        newStartMinutes
    );

    emailReminderStore.customReminderDate = newCustomReminderDate;
});
